"use strict";

// HtmlHelper
module.exports = {
	addIdToDataComponents: function($selector) {
		var $body = $("body");
		$selector = $selector || $("body");
		$selector.find("[data-component]:not([id])").addBack("[data-component]:not([id])").each((index, element) => {
			var newId = this.getId($body);
			element.setAttribute("id", newId);
		});
	},

	//random id generator - DDC
	getId: function ($contents, min, max, usage) {
		// Usage parameter is used to determine if the id is currently in use on the page
		usage = usage || "#{0}";
		var possibleLetters = "abcdefghijklmnopqrstuvwxyz";
		var letter,
			number,
			id;

		min = !min && min !== 0 ? 0 : min;
		max = !max && max !== 0 ? 100000 : max;

		//To ensure uniqueness, keep generating random ids until a unique one is genterated.
		//This should execute only once in the vast majority of cases.
		do {
			number = Math.floor(Math.random() * (max - min + 1)) + min;
			letter = possibleLetters.charAt(Math.floor(Math.random() * possibleLetters.length));
			id = `${letter}${number}`;
		} while ($contents.find(usage.replace("{0}", id)).length > 0);

		return id;
	},

	safeClassName: function (name) {
		name = name.replace(/[^a-z0-9]/g, (match, offset, original) => {
			var current = match.charCodeAt(0);

			// Replace spaces with _
			if (current == 32) return "_";

			// Replace upper case with lower case
			if (current >= 65 && current <= 90) {
				if (offset > 0) {
					// If the previous character was lowercase, replace upper with _lower
					var previousCharacter = original[offset - 1].charCodeAt(0);
					if (previousCharacter >= 97 && previousCharacter <= 122) {
						return "_" + match.toLowerCase();
					}
				}
				return match.toLowerCase();
			}

			// Replace special characters with hex value
			return "__" + ("000" + current.toString(16)).slice(-4);
		});

		// Make sure first character is _
		if (name[0] !== "_") name = "_" + name;
		return name;
	},

	setUniqueFormId: function($form, newId) {
		if (!$form || !newId) {
			return false;
		}

		var $submitButton = $form.find("[data-component='submitButton']");

		$form.attr("id", newId);
		$submitButton.attr("form", newId);
	},

	focusAndSelectFirstField: function($parnet) {
		$parnet.find("input, select, textarea, button").first().focus().select();
	},

	deleteChildOfColumnAndPromoteColumnChildren: function($itemToDelete) {
		var $currentColumn = $itemToDelete.parent();
		var $currentRow = $currentColumn.parent();
		var $previousColumn = null;

		//Remove the item to delete
		$itemToDelete.remove();

		//Then move all columns after $itemToDelete in the row to previous column placement
		while ($currentColumn.next().length) {
			$previousColumn = $currentColumn;
			$currentColumn = $currentColumn.next();
			$previousColumn.append($currentColumn.children());
		}

		while ($currentRow.next().length) {
			//Go to the next row
			$currentRow = $currentRow.next();
			$previousColumn = $currentColumn;
			$currentColumn = $currentRow.children().first();

			//Move from next row, first column to previous row, last column
			if ($currentColumn) {
				$previousColumn.append($currentColumn.children());
			}

			//Go through all additional columns on the row to move columns to previous
			while ($currentColumn.next().length) {
				$previousColumn = $currentColumn;
				$currentColumn = $currentColumn.next();
				$previousColumn.append($currentColumn.children());
			}
		}

		//Delete the last column
		if ($currentColumn.length && !$currentColumn.children("div").length) {
			$currentColumn.remove();
		}

		//If there are no more columns on the row, delete the last row
		if ($currentRow.length && !$currentRow.children("div").length) {
			$currentRow.remove();
		}
	},

	addColumnToLastOrNewRow: function ($itemToAdd, $rowContainer) {
		var supportedColCount = 0;

		// Get last row in the wrapper
		var $lastRow = $rowContainer.children("div[class='row']").last();

		if ($rowContainer.attr("data-chunk")) {
			// Pull number of supported columns from the data-chunk attribute if it exists.
			supportedColCount = $rowContainer.attr("data-chunk");
		} else {
			// Get column size from the attribute
			var $col = $lastRow.find("div[class^='col-']").first();
			var className = $col.attr("class");
			var size = className.replace(/col-(xs|sm|md|lg)-/, "");

			// Check to see if we have a full set of columns
			supportedColCount = 12 / size;
		}

		var actualColCount = $lastRow.children("div[class^='col-']").length;
		if (actualColCount < supportedColCount) {
			// We can append to this row
			$lastRow.append($itemToAdd);
		} else {
			// We need to add a new row
			var $newRow = $("<div></div>")
				.addClass("row")
				.attr("id", this.getId($("body")))
				.append($itemToAdd);
			$rowContainer.append($newRow);
		}

	}
};



// WEBPACK FOOTER //
// ./Javascript/shared/HtmlHelper.jsx